// JS
import React, { Suspense } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { randomId } from '../shared/utils';

// DATA
import * as sizes from './exisitingSizeGuideData';

// COMP
import { LoadingSpinner } from '../LoadingSpinner';
const uniqueId = randomId();

/* EXISTING SIZE GUIDE - FOOTWEAR */
export const footwearSizeGuide = [
  <div key={1} id="footwear-size-guide">
    <div className="footwear-container">
      <h2 className="footwear-heading">Footwear Size Chart</h2>
      <div className="footwear-body">
        <div className="footwear-column-row">
          <div className="footwear-country">
            <div className="location">uk</div>
            <div className="location">us</div>
            <div className="location">eu</div>
            <div className="location last">cm</div>
          </div>
          <div className="footwear-chart">
            <div className="footwear-chart-data">
              <ul>
                {sizes.sizeListUK &&
                  sizes.sizeListUK.map((size) => (
                    <li key={size.number} alt={size.alt}>
                      {size.number}
                    </li>
                  ))}
              </ul>
              <ul>
                {sizes.sizeListUS &&
                  sizes.sizeListUS.map((size) => (
                    <li key={size.number} alt={size.alt}>
                      {size.number}
                    </li>
                  ))}
              </ul>
              <ul>
                {sizes.sizeListEU &&
                  sizes.sizeListEU.map((size) => (
                    <li key={size.number} alt={size.alt}>
                      {size.number}
                    </li>
                  ))}
              </ul>
              <ul>
                {sizes.sizeListCM &&
                  sizes.sizeListCM.map((size) => (
                    <li key={size.number} alt={size.alt}>
                      {size.number}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
        <p>
          All footwear sizes displayed on our website are UK sizes, however some
          products may display EU sizes on the box or shoe itself.
        </p>
        <p>
          European scales do not exactly match UK scales and may vary from brand
          to brand.
        </p>
      </div>
    </div>
  </div>
];

/* EXISTING SIZE GUIDE - CLOTHING */
export const clothingSizeGuide = [
  <div key={2} id="clothing-brand-size-guide">
    <Tabs>
      <TabList className="react-tabs__tab-list tab-list-main">
        <Tab>Size Chart</Tab>
        <Tab>Brand Size Chart</Tab>
      </TabList>
      <TabPanel>
        <Suspense fallback={<LoadingSpinner />}>
          <Tabs>
            <TabList className="react-tabs__tab-list tab-list-main tab-list-sub">
              {sizes.mapRegionName &&
                sizes.mapRegionName.map((size, index) => (
                  <Tab key={uniqueId + index}>{size.name}</Tab>
                ))}
            </TabList>
            {sizes.mapRegions &&
              sizes.mapRegions.map((size, index) => (
                <TabPanel key={uniqueId + index}>
                  <Suspense fallback={<LoadingSpinner />}>
                    {size.region}
                  </Suspense>
                </TabPanel>
              ))}
          </Tabs>
          <p className="clothing-brand-size-guide-copy">
            *All sizes on site are UK sizes.
          </p>
        </Suspense>
      </TabPanel>
      <TabPanel>
        <Suspense fallback={<LoadingSpinner />}>
          <Tabs className="mr-[-25px] md:m-0">
            <TabList className="react-tabs__tab-list tab-list-main tab-list-brands">
              {sizes.mapBrandName &&
                sizes.mapBrandName.map((size, index) => (
                  <Tab key={uniqueId + index}>{size.name}</Tab>
                ))}
            </TabList>
            {sizes.mapBrands &&
              sizes.mapBrands.map((size, index) => (
                <TabPanel key={uniqueId + index}>
                  <Suspense fallback={<LoadingSpinner />}>
                    {size.brand}
                  </Suspense>
                </TabPanel>
              ))}
          </Tabs>
          <p className="clothing-brand-size-guide-copy">
            *All sizes on site are UK sizes.
          </p>
        </Suspense>
      </TabPanel>
    </Tabs>
  </div>
];
